import {
	type ClientPropertyLandDetailResponseDTO,
	ClientPropertyTypeEnum,
} from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { EditLandForm } from "web_myplann/Portfolio/Pages/LandEdit/EditLandForm";
import { PropertyEditLayout } from "web_myplann/Portfolio/PortfolioShared/PropertyEditLayout";

export const EditLandPage = () => {
	const { t } = useResource();

	return (
		<PropertyEditLayout<ClientPropertyLandDetailResponseDTO>
			expectedTypes={[ClientPropertyTypeEnum.Land]}
			title={t(Resources.Portfolio.EditProperty.title)}
		>
			{({ property, propertyId, detailRoute }) => (
				<EditLandForm
					propertyId={propertyId}
					property={property}
					detailRoute={detailRoute}
				/>
			)}
		</PropertyEditLayout>
	);
};
